import { useQuery } from '@tanstack/react-query';
import { Input } from '@upme/ui/components/input';
import { Switch } from '@upme/ui/components/switch';
import { useUpdateSettings } from '../mutations';
import { morningSettingsOptions } from '../queries';

export function MorningGeneralTab() {
  const { data } = useQuery(morningSettingsOptions());
  const update = useUpdateSettings();
  if (!data) return <div className="p-4">Загрузка…</div>;
  return (
    <div className="max-w-md space-y-4 p-4">
      <div className="flex items-center justify-between">
        <span>Блок погоды</span>
        <Switch checked={data.weatherEnabled} onCheckedChange={(v) => update.mutate({ weatherEnabled: v })} />
      </div>
      <div className="flex items-center justify-between">
        <span>Блок событий</span>
        <Switch checked={data.eventsEnabled} onCheckedChange={(v) => update.mutate({ eventsEnabled: v })} />
      </div>
      <div className="flex items-center justify-between gap-4">
        <span>Сколько событий показывать</span>
        <Input
          type="number"
          min={1}
          max={10}
          defaultValue={data.eventsLimit}
          className="w-24"
          onBlur={(e) => {
            const n = Number.parseInt(e.target.value, 10);
            if (Number.isInteger(n) && n > 0 && n !== data.eventsLimit) update.mutate({ eventsLimit: n });
          }}
        />
      </div>
    </div>
  );
}
